import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "base-echart" }

import { ref, onMounted, withDefaults, watchEffect } from 'vue'
import { EChartsOption } from 'echarts'
import useEchart from '../hooks/useEchart'

// 定义props

export default _defineComponent({
  props: {
    options: { type: null, required: true },
    width: { type: String, required: false, default: '100%' },
    height: { type: String, required: false, default: '360px' }
  } as unknown as undefined,
  setup(__props: {
    options: EChartsOption
    width?: string
    height?: string
  }) {

const props = __props


const echartDivRef = ref<HTMLElement>()

onMounted(() => {
  const { setOptions } = useEchart(echartDivRef.value!)

  watchEffect(() => {
    setOptions(props.options)
  })
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      ref: echartDivRef,
      style: _normalizeStyle({ width: __props.width, height: __props.height })
    }, null, 4)
  ]))
}
}

})